import { dateFromISOString } from '@wz-utilities/date.utilities';
import { HealthApiModels } from 'models/api/health-api.models';
import { HealthModels } from 'models/health.models';

export function projectDirectDebitFileTableRow(
  apiRow: HealthApiModels.DirectDebitFileTableRow,
): HealthModels.DirectDebitFileTableRow {
  return {
    ...apiRow,
    creationDate: dateFromISOString(apiRow.creationDate) ?? new Date(),
    executionDate: dateFromISOString(apiRow.executionDate!) ?? new Date(),
  };
}

export function projectRejectFileTableRow(
  apiRow: HealthApiModels.RejectFileTableRow,
): HealthModels.RejectFileTableRow {
  return {
    ...apiRow,
    creationDate: dateFromISOString(apiRow.creationDate) ?? new Date(),
    executionDate: dateFromISOString(apiRow.executionDate!) ?? new Date(),
    isMarkingAsDone: false,
  };
}
